'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }
    setSubmitted(true);
    setError('');
  };

  return (
    <>
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main className="min-h-screen bg-void flex items-center justify-center pt-16 pb-20 px-6">
        <div
          className="fixed inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse 70% 60% at 50% 50%, rgba(123,47,247,0.14) 0%, transparent 70%)' }}
        />

        <div className="relative z-10 w-full max-w-lg text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[rgba(123,47,247,0.4)] bg-[rgba(123,47,247,0.08)] mb-8">
            <span className="w-2 h-2 rounded-full" style={{ background: '#7B2FF7' }} />
            <span className="text-[11px] font-medium tracking-[0.15em] uppercase" style={{ color: '#7B2FF7' }}>
              Coming Soon
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-serif font-bold mb-4" style={{ fontSize: 'clamp(2.2rem, 6vw, 4rem)', color: 'var(--cream)' }}>
            Membership Registration{' '}
            <em className="not-italic" style={{ color: '#7B2FF7' }}>Coming Soon</em>
          </h1>

          <p className="text-base font-light leading-relaxed mb-10" style={{ color: 'rgba(240,230,211,0.55)' }}>
            Be part of a purpose-driven community. Join the waitlist and be the first to know when membership opens.
          </p>

          {/* Waitlist form */}
          {!submitted ? (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div
                className="rounded-2xl p-6"
                style={{ background: '#111124', border: '1px solid rgba(240,230,211,0.08)' }}
              >
                <label className="block text-[11px] font-medium tracking-[0.15em] uppercase mb-3 text-left" style={{ color: 'rgba(240,230,211,0.45)' }}>
                  Email Address
                </label>
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(''); }}
                    placeholder="your@email.com"
                    className="flex-1 rounded-xl px-5 py-3.5 text-sm font-medium outline-none"
                    style={{
                      background: 'rgba(240,230,211,0.05)',
                      border: error ? '1px solid rgba(239,68,68,0.5)' : '1px solid rgba(240,230,211,0.12)',
                      color: 'var(--cream)',
                      fontFamily: 'DM Sans, sans-serif',
                    }}
                  />
                  <button type="submit" className="cta-pill px-7 py-3.5 text-sm font-semibold whitespace-nowrap">
                    Join Waitlist
                  </button>
                </div>
                {error && (
                  <p className="mt-3 text-sm text-left" style={{ color: '#ef4444' }}>{error}</p>
                )}
              </div>
            </form>
          ) : (
            <div
              className="rounded-2xl p-8"
              style={{ background: 'rgba(74,222,128,0.06)', border: '1px solid rgba(74,222,128,0.25)' }}
            >
              <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" style={{ background: 'rgba(74,222,128,0.15)' }}>
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" style={{ color: '#4ade80' }}>
                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="font-serif font-semibold text-xl mb-2" style={{ color: 'var(--cream)' }}>
                You're on the list!
              </h3>
              <p className="text-sm" style={{ color: 'rgba(240,230,211,0.55)' }}>
                We'll notify you at <strong style={{ color: 'var(--cream)' }}>{email}</strong> when membership opens.
              </p>
            </div>
          )}

          {/* Stats */}
          <div className="mt-12 grid grid-cols-3 gap-4">
            {[
              { v: '8,500+', l: 'Members Waiting' },
              { v: 'Q2 2025', l: 'Expected Launch' },
              { v: 'Free', l: 'To Join Waitlist' },
            ].map((s) => (
              <div key={s.l} className="rounded-xl p-4 text-center" style={{ background: 'rgba(123,47,247,0.06)', border: '1px solid rgba(123,47,247,0.15)' }}>
                <p className="text-xl font-bold font-serif mb-1" style={{ color: '#7B2FF7' }}>{s.v}</p>
                <p className="text-[10px] font-medium tracking-wide" style={{ color: 'rgba(240,230,211,0.4)' }}>{s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
